import { gql } from '@apollo/client';

export const LOGIN = gql`
  query login {
    login {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation update_user_profile($data: UpdateUserProfileInputType) {
    update_user_profile(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_USER = gql`
  query get_user($data: GetUserInputType) {
    get_user(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_OWNER_PROFILE = gql`
  mutation update_owner_profile($data: UpdateOwnerProfileInputType!) {
    update_owner_profile(data: $data) {
      data
      hasError
      message
    }
  }
`;
